import enDictionary from "./en.json";
import arDictionary from "./ar.json";
import { ObjectKeysAsString } from "@/types";
import { Locale } from "@/i18n-config";

export * from "@/i18n-config";
type Dictionary = typeof enDictionary | typeof arDictionary;
export type AvailableDictionaryStrings = ObjectKeysAsString<Dictionary>;

const dictionaries: Record<Locale, Dictionary> = {
  en: enDictionary,
  ar: arDictionary,
};

export const getDictionary = (locale: Locale) => {
  return dictionaries[locale];
};

function parseDictionary(
  dictionary: Dictionary,
  pathString: AvailableDictionaryStrings
): string {
  let translation: any = dictionary;
  const pathArray = pathString.split(".");

  pathArray.forEach((i) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- because translation of type any
    translation = translation?.[i];
  });

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- we sure what we returning it just hard to play with recursive types
  return translation ?? pathString;
}

export const useTranslate = (
  locale: Locale
): {
  t: (pathString: AvailableDictionaryStrings) => string;
} => {
  const currentDictionary = getDictionary(locale);

  const translate = (pathString: AvailableDictionaryStrings): string => {
    return parseDictionary(currentDictionary, pathString);
  };

  return { t: translate };
};

export const directTranslate = (
  locale: Locale,
  pathString: AvailableDictionaryStrings
) => {
  const dictionary = getDictionary(locale);

  return parseDictionary(dictionary, pathString);
};
